import { call, cps, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
    BOOKING_CALCULATE_BESTRATE_SAGA,
    BOOKING_CLEAR_LOADING,
    BOOKING_GET_EDITING_INVOICE_POSITION_SAGA,
    BOOKING_SET_EDITING_INVOICE_POSITION,
    GET_RATE_SUGGESTIONS_SAGA,
} from "@/Redux/Booking/Constants";
import { fetchQuery } from "relay-runtime";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import { Environment } from "react-relay";
import CalculateBestRateMutation from "@/Domains/BookingManagement/Booking/Shared/Mutations/CalculateBestRateMutation";

function* bookingCalculateBestRateSaga(action: any) {
    const { callback } = action.payload;

    try {
        // @ts-ignore
        const data = yield cps(CalculateBestRateMutation, {
            bookingId: action.payload.bookingId,
            customerId: action.payload.customerId,
            enddate: action.payload.enddate,
            tmpBookingId: action.payload.tmpBookingId,
            plannedDistance: action.payload.plannedDistance,
            startdate: action.payload.startdate,
            startstation: action.payload.startstation,
            vehicleGroup: action.payload.vehicleGroup,
            voucherCode: action.payload.voucherCode,
            pricelist: action.payload.pricelist,
        });

        yield call(callback, null);
    } catch (e: any) {
        yield call(callback, e.message);
    }
}

function* bookingGetEditingInvoicePositionSaga(action: any) {
    if (action.data.id === -1) {
        yield put({
            type: BOOKING_SET_EDITING_INVOICE_POSITION,
            data: { editingInvoicePosition: {} },
        });
        return;
    }
    try {
        // @ts-ignore
        const invoicePosition = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query BookingSagasGetEditingInvoicePositionQuery(
                    $invoicePositionId: Int!
                ) {
                    invoicePosition(invoicePositionId: $invoicePositionId) {
                        invoicePositionId
                        position
                        rate
                        group
                        description
                        amount
                        netSinglePrice
                        grossPrice
                        discount
                        netTotalPrice
                        includedDistance
                        bookingId
                    }
                }
            `,
            {
                invoicePositionId: action.data.id,
            },
            {
                networkCacheConfig: {
                    force: true,
                },
            },
        )
            .toPromise()
            .then((data) => {
                // @ts-ignore
                return data.invoicePosition;
            })
            .catch((error) => {
                throw error;
            });
        let editingInvoicePosition = {};
        editingInvoicePosition = JSON.parse(JSON.stringify(invoicePosition));
        yield put({
            type: BOOKING_SET_EDITING_INVOICE_POSITION,
            data: { editingInvoicePosition: editingInvoicePosition },
        });
        yield put({ type: BOOKING_CLEAR_LOADING });
    } catch (e: any) {
        console.error(e);
    }
}

function* getRateSuggestionsSaga(action: any) {
    const { callback } = action.payload;

    try {
        // @ts-ignore
        const rates = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query BookingSagasGetRateSuggestionsSagaQuery(
                    $customerId: String!
                    $pricelist: String!
                    $rate: String!
                    $rateDescription: String!
                    $showCustomerRates: Boolean
                    $showMainRates: Boolean
                    $showSubrates: Boolean
                    $station: String!
                    $vehicleGroupId: String!
                ) {
                    rateSuggestionList(
                        customerId: $customerId
                        pricelist: $pricelist
                        rate: $rate
                        rateDescription: $rateDescription
                        showCustomerRates: $showCustomerRates
                        showMainRates: $showMainRates
                        showSubrates: $showSubrates
                        station: $station
                        vehicleGroupId: $vehicleGroupId
                    ) {
                        rateSuggestions {
                            rate
                            account
                            description
                            freeKm
                            price
                            priceAdditional
                            priceAdditionalKm
                            unit
                        }
                    }
                }
            `,
            {
                customerId: action.payload.customerId || "",
                pricelist: action.payload.pricelist,
                rate: action.payload.rate,
                rateDescription: action.payload.rateDescription,
                showCustomerRates: action.payload.showCustomerRates,
                showMainRates: action.payload.showMainRates,
                showSubrates: action.payload.showSubrates,
                station:
                    action.payload.station == "-1"
                        ? ""
                        : action.payload.station,
                vehicleGroupId:
                    action.payload.vehicleGroupId == "-1"
                        ? ""
                        : action.payload.vehicleGroupId,
            },
            {
                networkCacheConfig: {
                    force: true,
                },
            },
        )
            .toPromise()
            .then((data) => {
                // @ts-ignore
                return data.rateSuggestionList.rateSuggestions;
            })
            .catch((error) => {
                throw error;
            });

        callback(null, rates);
    } catch (e: any) {
        console.error(e);
    }
}

function* BookingSagas() {
    yield takeEvery(
        BOOKING_CALCULATE_BESTRATE_SAGA,
        bookingCalculateBestRateSaga,
    );
    yield takeLatest(
        BOOKING_GET_EDITING_INVOICE_POSITION_SAGA,
        bookingGetEditingInvoicePositionSaga,
    );
    yield takeEvery(GET_RATE_SUGGESTIONS_SAGA, getRateSuggestionsSaga);
}

export default BookingSagas;
